import axios from 'axios';

import {
  getRoleSelected,
  getToken,
  logout,
  getProjectSelected,
  getSlugSelected,
  getDatabaseSelected,
} from '../services/auth';

axios.defaults.baseURL = process.env.REACT_APP_API;

axios.interceptors.request.use(async (config) => {
  const token = getToken();
  const selectedRole = getRoleSelected();

  if (token && selectedRole) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.Role = selectedRole;
  }
  config.headers.slug = getSlugSelected();
  config.headers.project = getProjectSelected();
  config.headers.database = getDatabaseSelected();

  return config;
});

axios.interceptors.response.use(
  function (response) {
    if (response && response.headers && response.headers.version) {
      const versionApi = response.headers.version;
      const versionStorage = localStorage.getItem('version_api');
      localStorage.setItem('version_api', versionApi);

      if (
        versionStorage &&
        versionStorage.length > 0 &&
        versionApi &&
        versionApi.length > 0 &&
        versionStorage != versionApi
      ) {
        window.location.reload();
      }
    }

    if (response && response.data && response.data.error) {
      return Promise.reject(response);
    }

    return response;
  },
  (error) => {
    if (error && error.response) {
      if (error.response.status && error.response.status === 401) {
        logout();
        window.location.reload();
      }

      return Promise.reject(error.response);
    }
  },
);

export default axios;
